import { Line, mixins } from 'vue-chartjs';
var reactiveProp = mixins.reactiveProp;
export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  } // eslint-disable-next-line no-tabs

  /*	watch: {
  		options: function() {
  			console.debug('change chart options', this.options)
  			this.$data._chart.destroy()
  			this.renderChart(this.chartData, this.options)
  		},
  	}, */

};